export default __webpack_public_path__ + "static/media/02.7cc6ef54.jpg";